import React from 'react';
import { useSubcatalogSpecializationLinks } from 'src/entities/catalog';
import { CatalogSpecializationTagCloudProps } from './types';
import { TagCloud } from './tagCloud';

export const CatalogSpecializationTagCloud: React.FC<CatalogSpecializationTagCloudProps> = (props) => {
  const { links } = useSubcatalogSpecializationLinks(props);

  return <TagCloud items={links} size="small" unfilled {...props} />;
};
